import React, { useState ,useRef,useEffect} from 'react';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-6/mainSection-multiple-inputs-v-6';
import buyerService from './buyer.service';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import DynamicDuplicate from '../software-dynamic-version-6/check-duplicate-v-6';

const BuyerAdd = (props) => {
 console.log(props)
 

   let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key],
          };
        }
      });
      return updatedValues;
    });
  };
  const optionalCols = props.optionalColumns || [];
  const has = (c) => optionalCols.includes(c);
  
  const [inputProps, setInputProps] = useState({
    // buyerNTNCNIC: {
    //   name: 'buyerNTNCNIC',
    //   caption: 'Buyer NTN/CNIC',
    //   value: props.buyerNTNCNIC || '',
    //   enabled:props.isAdd
    // },
    buyerNTNCNIC: {
      name: 'buyerNTNCNIC',
      caption: props.BusinessTypeProps === 'Vendor' ? 'Vendor NTN/CNIC' : 'Buyer NTN/CNIC',
      value: props.buyerNTNCNIC || '',
      enabled: props.isAdd
    },
    // buyerBusinessName: {
    //   name: 'buyerBusinessName',
    //   caption: 'Buyer Business Name',
    //   value: props.buyerBusinessName || ''
    // },
    buyerBusinessName: {
      name: 'buyerBusinessName',
      caption: props.BusinessTypeProps === 'Vendor' ? 'Vendor Business Name' : 'Buyer Business Name',
      value: props.buyerBusinessName || ''
    },
    stateProvinceName: {
      name: { id: 'stateProvinceCode', value: 'stateProvinceName' },
      caption: 'Select Province',
      value: {
        id: props.buyerProvinceCode || '',
        value: props.buyerProvinceName || ''
      },
      dataSource: { type: 'Data', data: [] }
    },
    // buyerAddress: {
    //   name: 'buyerAddress',
    //   caption: 'Buyer Address',
    //   value: props.buyerAddress || ''
    // }
    buyerAddress: {
      name: 'buyerAddress',
      caption: props.BusinessTypeProps === 'Vendor' ? 'Vendor Address' : 'Buyer Address',
      value: props.buyerAddress || ''
    },
    buyerRegistrationType: {
      name: 'buyerRegistrationType',
      caption: 'Buyer Registration Type',
      value: props.buyerRegistrationType || null
    },
    sellerNTNCNIC: {
      name: 'sellerNTNCNIC',
      caption: 'Seller NTN/CNIC',
      value: props.sellerNTNCNIC || null
    },
    buyerContactPerson: {name: "buyerContactPerson", caption: "Contact Person", value: props.buyerContactPerson || ""},
buyerContactNumber: {name: "buyerContactNumber", caption: "Contact Number", value: props.buyerContactNumber || ""},
buyerSTRN: {name: "buyerSTRN", caption: "Buyer STRN", value: props.buyerSTRN || ""},
buyerCNIC: {name: "buyerCNIC", caption: "Buyer CNIC", value: props.buyerCNIC || ""},

// ADD THIS ↓
buyerNTNCNICReferenceNo: {
  name: 'buyerNTNCNICReferenceNo',
  caption: 'NTN/CNIC Reference No',
  value: props.buyerNTNCNICReferenceNo || '',
},
IsActiveBuyer: {
  name: 'IsActiveBuyer',
  caption: `Is Active ${props.BusinessTypeProps || 'Buyer'}`,
  value: props.IsActiveBuyer === "Yes" || props.IsActiveBuyer === true || props.isAdd == true ? 1 : 0,   // default true for new buyer
},
BusinessType: {
  name: 'BusinessType',
  value: props.BusinessTypeProps || 'Buyer',
}
  });


  useEffect(()=>{
    return ()=>{
    hideTooltip(); // remove previous tooltip
    }
  },[])
  const getProvincesSource = async () => {
    const response = await buyerService.getCompanyView();
    const { data } = await buyerService.getProvincesDD(response.data.recordset[0].CompanyID);
    console.log(data)
    const recordsMapping = (data || []).map((row) => ({
      id: row.stateProvinceCode,
      value: row.stateProvinceDesc
    }));

    updateMainSecionsValue({
      stateProvinceName: {
        dataSource: { type: 'Data', data: recordsMapping }
      }
    });
    setTimeout(() => {
      
      if(props.isAdd == false){
        updateMainSecionsValue({
          stateProvinceName: {
            value:{ value:{ id: props.buyerProvinceCode, value: props.buyerProvinceName }}
          }
        });
      }
    }, 500);
  };


  // ==================================================
// 🔥 Validate Buyer NTN (7 chars, alphanumeric only)
// ==================================================

  
const tooltipRef = useRef(null);

const showTooltip = (target, message) => {
   if (tooltipRef.current) {
     tooltipRef.current.destroy(); // Destroy existing tooltip if any
   }
   tooltipRef.current = new TooltipComponent({
     content: `<span class="error-tooltip">${message}</span>`,
     position: 'TopCenter',
   });
   tooltipRef.current.appendTo(target);
   tooltipRef.current.open(target);
 };
 
 const hideTooltip = () => {
   if (tooltipRef.current) {
     try {
       // Check if close method exists and tooltip is still mounted
       if (tooltipRef.current.close && typeof tooltipRef.current.close === 'function') {
         tooltipRef.current.close();
       }
       // Check if destroy method exists and tooltip is still mounted
       if (tooltipRef.current.destroy && typeof tooltipRef.current.destroy === 'function') {
         tooltipRef.current.destroy();
       }
     } catch (error) {
       // Silently handle errors when tooltip is already unmounted
       console.warn('Tooltip cleanup error (safe to ignore):', error.message);
     } finally {
       // Always reset the ref regardless of success/failure
       tooltipRef.current = null;
     }
   }
 };


 const SaveButton = (GridID, visibility) => {
  const btn = document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`);
  if (btn) btn.style.visibility = `${visibility}`;
}

const validateBuyerNTN = (value, inputId = "buyerNTNCNIC") => {

  const inputField = document.getElementById(inputId);
  if (!inputField) return false;
  
  setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 100);
  hideTooltip(); // remove previous tooltip

  if (!value) {
    showTooltip(inputField, "Buyer NTN is required");
    inputField.focus();
    // setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }


  // --- remove all characters except A-Z and 0-9 ---
  const cleanValue = value.replace(/[^A-Za-z0-9]/g, "");

  // update field if characters were removed
  if (cleanValue !== value) {
    inputField.value = cleanValue;
  }

  // --- allow only 7 characters ---
  if (cleanValue.length <  7) {
    showTooltip(inputField, `IF YOU ARE ENTERING NTN, IT SHOULD BE 7 CHARACTERS LONG
    IF YOU ARE ENTERING CNIC, IT SHOULD BE 13 CHARACTERS LONG`);
    // inputField.focus();
    // setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }
  if (cleanValue.length > 7 &&  cleanValue.length !== 13) {
    showTooltip(inputField,  `IF YOU ARE ENTERING NTN, IT SHOULD BE 7 CHARACTERS LONG
    IF YOU ARE ENTERING CNIC, IT SHOULD BE 13 CHARACTERS LONG`);
    // inputField.focus();
    // setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }
  if(cleanValue.length > 13){
    setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    return false;
  }

  setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 100);
  return true; 
};
const validateReferenceNo = (refValue, ntnValue, lockFocus = false) => {
  const wrapper = document.getElementById('buyerNTNCNICReferenceNo');
  if (!wrapper) return false;

  // ✅ actual input element — wrapper ke andar
  console.log(wrapper.tagName)
  const inputField = wrapper.tagName === 'INPUT' 
    ? wrapper 
    : wrapper.querySelector('input');
    console.log(wrapper)
  if (!inputField) return false;

  const ntnClean = (ntnValue || '').replace(/[^A-Za-z0-9]/g, '');

  const triggerFocusSelect = () => {
    if (lockFocus == true) {
      console.log(lockFocus)
      setTimeout(() => {
        inputField.focus();
        
      }, 5);
      setTimeout(() => {
        inputField.select();
      }, 10);
    }
  };

  // --- check max length 9 FIRST ---
  if (refValue && refValue.length > 9) {
    showTooltip(wrapper, 'Reference No max length is 9 characters');
    setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
    triggerFocusSelect();
    return false;
  }

  // --- if NTN is 7 chars, reference no is required ---
  if (ntnClean.length === 7) {
    if (!refValue || refValue.trim() === '') {
      showTooltip(wrapper, 'Reference No is required when NTN is 7 characters');
      triggerFocusSelect();
      setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 100);
      return false;
    }
  }

  // --- all good ---
  hideTooltip();
  setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 100);
  return true;
};

  const handleInputCreated = async (e, name) => {
    if (name === 'stateProvinceName') {
      getProvincesSource();
    }
    console.log(`Input ${name} created`, e);
  };

  const handleInputChange = async (value, name) => {
    console.log(value);
    if (name === 'buyerNTNCNIC') {
      validateBuyerNTN(value);
     
    }
    if (name === 'buyerNTNCNICReferenceNo') {
      validateReferenceNo(value, inputProps.buyerNTNCNIC.value); // no lockFocus while typing
    }
  };
  const handleInputBlur = (value, name) => {
    if (name === 'buyerNTNCNIC') {
      const clean = (value || '').replace(/[^A-Za-z0-9]/g, '');
  
      // auto-fill only when exactly 7 chars (NTN)
      if (clean.length === 7) {
        updateMainSecionsValue({
          buyerNTNCNICReferenceNo: { value: clean }
        });
      }
  
      // on blur — if error, lock focus on NTN field
      const isValid = validateBuyerNTN(value);
      if (!isValid) {
        const inputField = document.getElementById('buyerNTNCNIC');
        if (inputField) {
          setTimeout(() => { inputField.focus(); inputField.select(); }, 0);
        }
        return; // NTN hi invalid hai, reference check mat karo abhi
      }
  
      // ✅ FIX: DOM se fresh value lo, stale closure se nahi
      setTimeout(() => {
        const refField = document.getElementById('buyerNTNCNICReferenceNo');
        const freshRefValue = refField ? refField.value : '';
        validateReferenceNo(freshRefValue, value);
      }, 100); // 1600 ki zaroorat nahi, DOM update fast hai
    }
  
    if (name === 'buyerNTNCNICReferenceNo') {
      validateReferenceNo(value, inputProps.buyerNTNCNIC.value, true);
    }
  };
  const inputsList = [
    { Input: TextComponent, Props: { ...inputProps.buyerNTNCNIC, setInputProps,onChange:handleInputChange,onBlur:handleInputBlur}, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.buyerBusinessName, setInputProps }, ColumnSize: 6 },
    {
      Input: DropdownComponent,
      Props: { ...inputProps.stateProvinceName, setInputProps, onCreated: handleInputCreated },
      ColumnSize: 6
    },
    { Input: TextComponent, Props: { ...inputProps.buyerAddress, setInputProps }, ColumnSize: 6 },
    ...(has("buyerContactPerson")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerContactPerson, setInputProps }, ColumnSize: 6 }]
    : []),

  ...(has("buyerContactNumber")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerContactNumber, setInputProps }, ColumnSize: 6 }]
    : []),

  ...(has("buyerSTRN")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerSTRN, setInputProps }, ColumnSize: 6 }]
    : []),

  ...(has("buyerCNIC")
    ? [{ Input: TextComponent, Props: { ...inputProps.buyerCNIC, setInputProps }, ColumnSize: 6 }]
    : []),

      { Input: TextComponent, Props: { ...inputProps.buyerNTNCNICReferenceNo, setInputProps, onChange: handleInputChange, onBlur: handleInputBlur, maxLength: 9 }, ColumnSize: 6 },
      { Input: CheckBoxComponent, Props: { ...inputProps.IsActiveBuyer, setInputProps }, ColumnSize: 6 },

    { Input: HiddenComponent, Props: { ...inputProps.buyerRegistrationType, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.sellerNTNCNIC, setInputProps }, ColumnSize: 6 },
    { Input: HiddenComponent, Props: { ...inputProps.BusinessType, setInputProps }, ColumnSize: 6 },

  ];

  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <StructuredGenerate
        mainProps={props}
        title={`${props.BusinessTypeProps === 'Vendor' ? 'Vendor' : 'Buyer'} - ${props.isAdd ? 'Add' : 'Edit'}`}

        Inputs={inputsList}
      />
      <DynamicDuplicate  
            wrapperId='BuyerGrid' 
            dataList={props.dataList} 
            dynamicFields={{
              buyerNTNCNIC:inputProps.buyerNTNCNIC.value,
              // AccessorySubCategoryCode:inputProps.AccessorySubCategoryCode.value
            }}
            IsAdd={props.isAdd}
            duplicateType={'withOut'} 
            parentColumn={'buyerNTNCNIC'}
            selectedRow={props}
            />
    </div>
  );
};

export default BuyerAdd;